module.exports = __webpack_public_path__ + "img/20190712164833YY截图20190711014503.3fe8f1b5.png";